import React from "react";
import ButtonToBottomSheet from "./ButtonToBottomSheet";

function TagPeopleButton({ taggedPeople = [], onPress }) {
  const value =
    taggedPeople.length > 0
      ? `${taggedPeople.length} person${taggedPeople.length === 1 ? "" : "s"} tagged`
      : "Tap to add";

  return (
    <ButtonToBottomSheet
      icon="people-outline"
      label="Tag people"
      value={value}
      onPress={onPress}
    />
  );
}

export default TagPeopleButton;
